'use strict';

var _ = require('lodash');
var JQXGridCellRendererFactory = function JQXGridCellRendererFactory(formulaEvalService) {
  var calculatedValueRenderer = function calculatedValueRenderer(columnContext, row, columnfield, value, defaultvalue, column, rowdata) {
    var computedValue = formulaEvalService.compute(columnContext.formula, rowdata);
    return defaultvalue.replace('><', '>' + computedValue + '<');
  };
  var booleanToYesNoValueRenderer = function booleanToYesNoValueRenderer(columnContext, row, columnfield, value, defaultvalue) {
    if (value === true) {
      return defaultvalue.replace('>true<', '>Yes<');
    } else if (value === false) {
      return defaultvalue.replace('>false<', '>No<');
    } else {
      return defaultvalue;
    }
  };
  var percentageRender = function percentageRender(columnContext, row, columnfield, value, defaultvalue, column, isAbsolute) {
    if (value !== '') {
      var formattedValue = isAbsolute ? Math.abs(Math.round(value * 10000) / 100) : Math.round(value * 10000) / 100;
      return defaultvalue.replace('>' + value + (column.cellsformat.indexOf('p') === -1 ? '' : '%') + '<', '>' + formattedValue + '<');
    }
    return defaultvalue;
  };
  var absolutePercentageRender = function absolutePercentageRender(columnContext, row, columnfield, value, defaultvalue, column) {
    return percentageRender(columnContext, row, columnfield, value, defaultvalue, column, true);
  };
  var flightNumberRender = function flightNumberRender(columnContext, row, columnfield, value, defaultvalue) {
    return defaultvalue.replace(/,/g, '');
  };
  var appliedByRenderer = function appliedByRenderer(columnContext, row, columnfield, value, defaultvalue, column, rowdata) {
    if (!rowdata.appliedByRuleId) {
      return defaultvalue;
    }
    return defaultvalue.replace('>' + value + '<', '><span class="grid-cell-link" ng-click="cellClickHandler(\'' + rowdata.appliedByRuleId + '\')">' + value + '</span><');
  };
  var ruleAppliesRenderer = function ruleAppliesRenderer(columnContext, row, columnfield, value) {
    return '<div class="jqx-grid-cell-middle-align" style="margin-top: 4px;">' + (_.includes(value, 'APPLIED') ? '<i class=\"spark-icon--fill spark-icon-check\" title="Applied"></i>' : '') + (_.includes(value, 'CONFLICT') ? '<i class=\"spark-icon--fill spark-icon-warning\" title="Conflict"></i>' : '') + '</div>';
  };
  var posBudgetTargetRenderer = function posBudgetTargetRenderer(columnContext, row, columnfield, value, defaultvalue, column, rowdata) {
    if (rowdata.targetType === 'LoadFactor') {
      return defaultvalue.replace('>' + value + '<', '><');
    }
    return defaultvalue;
  };
  var uppercaseValueRenderer = function uppercaseValueRenderer(columnContext, row, columnfield, value, defaultvalue) {
    return defaultvalue.replace('>' + value + '<', '>' + (value || '').toUpperCase() + '<');
  };
  var openTagEncoderRenderer = function openTagEncoderRenderer(columnContext, row, columnfield, value, defaultvalue) {
    var newValue = replaceAll('<', '&lt;', value);
    return defaultvalue.replace(value, newValue);
  };
  function replaceAll(toReplace, replaceWith, value) {
    var regExp = new RegExp(toReplace, 'g');
    return !_.isNil(value) ? value.toString().replace(regExp, replaceWith) : '';
  }
  var rendererMapping = {
    statusRenderer: _.identity,
    calculatedValue: calculatedValueRenderer,
    booleanToYesNoValue: booleanToYesNoValueRenderer,
    percentageRender: percentageRender,
    appliedByRenderer: appliedByRenderer,
    ruleAppliesRenderer: ruleAppliesRenderer,
    flightNumberRender: flightNumberRender,
    posBudgetTargetRenderer: posBudgetTargetRenderer,
    uppercaseValueRenderer: uppercaseValueRenderer,
    openTagEncoderRenderer: openTagEncoderRenderer,
    absolutePercentageRender: absolutePercentageRender
  };
  function getRenderer(rendererId) {
    var renderer = rendererMapping[rendererId];
    if (renderer === undefined) {
      throw new RangeError('Could not find cell renderer: \'' + rendererId + '\' ');
    }
    return renderer;
  }
  return {
    getRenderer: getRenderer
  };
};
JQXGridCellRendererFactory.$inject = ['FormulaEvalService'];
module.exports = JQXGridCellRendererFactory;